<div id="type" class="tabcontent">
  <div class="type-container">
    <label class="appearance-field-wrap">
      <input
        class="appearance-field"
        type="text"
        name="name"
        #signatureNameField
        [placeholder]="'Enter your name to get the signature appearance' | translate"
        [attr.maxlength]="valueTypeMaxLength"
        [formControl]="signatureNameControl"
        (input)="setData({ data: signatureNameControl.value }, dataTypes.Type)"
        ngAutofocus
      />
      <span class="appearance-field-btn-clear" *ngIf="signatureNameField.value.length" (click)="clearFiled()">
        <svg class="icon-svg">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#dialog-cross"></use>
        </svg>
      </span>
    </label>

    <div class="examples-wrapper" *ngIf="fonts && fonts.length">
      <div
        *ngFor="let font of fonts"
        [style.font-family]="font"
        [style.color]="color"
        [ngClass]="{
          hover: context.model.tabs[dataTypes.Type].data,
          active: context.model.tabs[dataTypes.Type].data && font === context.model.tabs[dataTypes.Type].styles.font
        }"
        (click)="onSelectedType(font, dataTypes.Type)"
      >
        {{ signatureNameControl.value }}
      </div>
    </div>
  </div>

  <input #enter style="pointer-events: none; display: none" />
</div>
